import { ChangeDetectorRef, Component, computed, Inject, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { FeedstockService } from '../../../../services/feedstockservice';
import { LookUpService } from '../../../../services/lookupservice';
import { CustomerData, GeneratorsList, genInput, SaveCustomerRequest } from '../../../../interfaces/generatorsmodel';
import { Regions } from '../../../../interfaces/regions';
import { Cities } from '../../../../interfaces/cities';
import { States } from '../../../../interfaces/states';
import { SiteService } from '../../../../services/siteservice';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SaveAttemptErrorMatcher } from '../../../shared/commonutils/errorStateDirective';
import { numericInputLimit } from '../../../shared/commonutils/helper';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-addedit-generator',
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatSlideToggleModule,
    DragDropModule
  ],
  templateUrl: './addedit-generator.component.html',
  styleUrl: './addedit-generator.component.scss'
})
export class AddeditGeneratorComponent implements OnInit {
  id = signal<number>(0);
  title : string = "Add Generator";
  customerName = signal<string>('');
  contactName = signal<string>('');
  contactPhone = signal<string>('');
  contactEmail = signal<string>('');
  addressLine1 = signal<string>('');
  addressLine2 = signal<string>('');
  city = signal<string>('');
  state = signal<string>('');
  zipCode = signal<string>('');
  siteNumber = signal<number | null>(null);
  accountNumber = signal<number | null>(null);
  MarketId = signal<number | null>(null);
  logisticsContactName = signal<string>('');
  logisticsContactPhone = signal<string>('');
  logisticsContactEmail = signal<string>('');
  environment_Fee_Flag = signal<boolean>(false);
  isVRSite = signal<boolean>(false);
  displayValue = signal<string>('');
  isSaving = signal(false);
  attemptSave = signal(false); // Flag to show validation errors on first save attempt
  message = signal<string>('');
  markets = signal<Regions[]>([]);  
  states = signal<States[]>([]);
  cities = signal<Cities[]>([]);
  private allStates: States[] = [];
  private allCities: Cities[] = [];
  canSave: boolean = false;

  isEditing = computed(() => this.id() > 0);
  matcher = computed(() => new SaveAttemptErrorMatcher(() => this.attemptSave()));
  isFormValid = computed(() => {
  const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
  const nameValid = this.customerName().trim().length > 0;
  const addr1Valid = this.addressLine1().trim().length > 0
  const stateValid = !!this.state();
  const cityValid = !!this.city();
  const zipValid = this.zipCode().length > 0;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const contactEmailValue = this.contactEmail() || '';
  const isContactEmailValid = contactEmailValue.length === 0 || (contactEmailValue.length > 0 && emailRegex.test(contactEmailValue));
  
  const contactPhoneValue = this.contactPhone() || '';
  const isContactPhoneValid = contactPhoneValue === '' || phoneRegex.test(contactPhoneValue);
  
  const logisticsEmailValue = this.logisticsContactEmail() || '';
  const isLogisticsEmailValid = logisticsEmailValue.length === 0 || (logisticsEmailValue.length > 0 && emailRegex.test(logisticsEmailValue));
  
  const logisticsPhoneValue = this.logisticsContactPhone() || '';
  const isLogisticsPhoneValid = logisticsPhoneValue === '' || phoneRegex.test(logisticsPhoneValue);
  const marketValid = this.MarketId() !== null;
  return nameValid && addr1Valid && stateValid && cityValid && zipValid && marketValid &&
         isContactEmailValid && 
         isContactPhoneValid && 
         isLogisticsEmailValid && 
         isLogisticsPhoneValid;
  });

  constructor(public dialogRef: MatDialogRef<AddeditGeneratorComponent>,
    private fsService: FeedstockService,
    private lookup: LookUpService,
    private siteService: SiteService,
    @Inject(MAT_DIALOG_DATA) public data: genInput,
    private cdr: ChangeDetectorRef) {
    console.log("incoming generator data: ", data);
    this.canSave = data.canSave;
    this.initializeFormFromData(data.data);
  }

  ngOnInit() {
    this.getMarketsData();
  }
  
  initializeFormFromData(data: GeneratorsList): void {
    if (data && data.id) {
      if (this.state() !== null && this.state() !== undefined) {
        const selectedState = this.states().find(state => state.state === data.state);
        this.state.set(selectedState ? `${selectedState.id}` : '');
      }
      this.title = data.generatorName;
      this.id.set(data.id || 0);
      this.customerName.set(data.generatorName || '');
      this.contactName.set(data.contactName || '');
      this.contactPhone.set(data.contactPhone || '');
      this.contactEmail.set(data.contactEmail || '');
      this.addressLine1.set(data.addressLine1 || '');
      this.addressLine2.set(data.addressLine2 || '');
      this.city.set(data.city || '');
      //this.state.set(data.state || '');
      this.zipCode.set(data.zipCode || '');
      this.siteNumber.set(data.siteNumber || null);
      this.accountNumber.set(data.accountNumber || null);
      this.MarketId.set(data.marketId || null);
      this.logisticsContactName.set(data.lgX_ContactName || '');
      this.logisticsContactPhone.set(data.lgX_ContactPhone || '');
      this.logisticsContactEmail.set(data.lgX_ContactEmail || '');
      this.environment_Fee_Flag.set(data.environment_Fee_Flag || false);
      this.isVRSite.set(data.isVRSite || false);
    }else{
      //this.MarketId.set(-1);
    }
  }

  isValidEmail(email: string): boolean {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  }

  formatPhoneNumber(event: Event, type: number): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '').substring(0, 10);
    let formattedValue = '';
    if (value.length > 0) {
      formattedValue = '(' + value.substring(0, 3);
    }
    if (value.length >= 4) {
      formattedValue += ') ' + value.substring(3, 6);
    }
    if (value.length >= 7) {
      formattedValue += '-' + value.substring(6, 10);
    }
    input.value = formattedValue;
    if(type === 1){
      this.contactPhone.set(formattedValue);
    }else{
      this.logisticsContactPhone.set(formattedValue);
    }
    input.value = formattedValue;
    this.cdr.detectChanges();
  }

  roundOff(event: Event, maxValue: number, maxDecimals: number, type: number): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;
    
    val = numericInputLimit(event, maxValue, maxDecimals);
    
    this.displayValue.set(val);
    input.value = val;

    // 6. Parsing for the backing variables
    const isValueEmpty = val === '' || val === '.';
    const parsedValue = maxDecimals === 0 ? parseInt(val, 10) : parseFloat(val);
    const finalValue = isValueEmpty ? null : parsedValue;
    switch(type){
      case 1:
        this.siteNumber.set(finalValue);
        break;
      case 2:
        this.accountNumber.set(finalValue);
        break;
    }
    requestAnimationFrame(() => {
      if (document.activeElement === input) {
          input.value = val;
      }
    });
  }

  filterStates(event: Event): void {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value.toLowerCase();
    this.states.set(searchTerm ? this.allStates.filter(s => s.state.toLowerCase().includes(searchTerm)) : [...this.allStates]);
  }

  filterCities(event: Event): void {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value.toLowerCase();
    this.cities.set(searchTerm ? this.allCities.filter(c => c.city.toLowerCase().includes(searchTerm)) : [...this.allCities]);
  }

  saveCustomerData() {
    this.attemptSave.set(true);
    this.cdr.detectChanges();
    if (!this.isFormValid()) {
      return;
    }

    this.isSaving.set(true);
    let stateName = '';
    if (this.state() !== null && this.state() !== undefined) {
      const selectedState = this.states().find(state => state.id === parseInt(this.state()));
      stateName = selectedState ? selectedState.state : '';
    }

    var payload: SaveCustomerRequest = {
      id: this.id(),
      name: this.customerName(),
      customerName: this.customerName(),
      contactName: this.contactName(),
      contactPhone: this.contactPhone(),
      contactEmail: this.contactEmail(),
      addressLine1: this.addressLine1(),
      addressLine2: this.addressLine2(),
      city: this.city(),
      state: stateName,
      zipCode: this.zipCode(),
      siteNumber: this.siteNumber(),
      accountNumber: this.accountNumber(),
      markets: this.MarketId(),
      lgx_ContactName: this.logisticsContactName(),
      lgx_ContactPhone: this.logisticsContactPhone(),
      lgx_ContactEmail: this.logisticsContactEmail(),
      environment_Fee_Flag: this.environment_Fee_Flag(),
      isVRSite: this.isVRSite()
    };
    

    console.log('Form data to save:', payload);

    this.fsService.saveGenerator(payload).subscribe({
      next: (response) => {
        console.log('Save successful:', response);
        this.dialogRef.close(true);
      }
    });
  }

  resetForm() {
    this.id.set(0);
    this.customerName.set('');
    this.contactName.set('');
    this.contactPhone.set('');
    this.contactEmail.set('');
    this.addressLine1.set('');
    this.addressLine2.set('');
    this.city.set('');
    this.state.set('');
    this.zipCode.set('');
    this.siteNumber.set(null);
    this.accountNumber.set(null);
    this.MarketId.set(null);
    this.attemptSave.set(false);
    this.logisticsContactName.set('');
    this.logisticsContactPhone.set('');
    this.logisticsContactEmail.set('');
    this.environment_Fee_Flag.set(false);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  getMarketsData(){
    this.lookup.getMarketsList("").subscribe({
      next: async (response) => {
        this.markets.set(response);
        this.message.set('');
        this.getStatesData();
      }
    })
  }
  
  getStatesData(): void {
    this.lookup.getStatesList().subscribe({
      next: (response: States[]) => {
        this.allStates = response;
        this.states.set(response);
        if (this.data.data !== null && this.data.data.state) {
          const selectedState = this.states().find(
            (s) => s.state === this.data.data.state
          );
          if (selectedState?.id) {
            this.onStateChanged(selectedState.id, true);
          }
        }
      },
    });
  }  

  onStateChanged(selectedState: number, isOnLoad?: boolean): void {
    if (selectedState) {
      this.siteService.getCitiesByState(selectedState).subscribe({
        next: (response: Cities[]) => {
          this.allCities = response;
          this.cities.set(response);
          if (isOnLoad && this.data.data.city) {
            const selectedCity = this.cities().find(
              (c) => c.city?.toLowerCase() === this.data?.data?.city?.toLowerCase()
            );
            if (selectedCity) {
              this.updateCityAndStateSelection(selectedCity.city, selectedState);
            }
          }
        },
      });
    }else{
      this.cities.set([]);
      this.updateCityAndStateSelection('', '');
    }
  }

  updateCityAndStateSelection(city: string, state: any): void {
    this.city.set(city);
    this.state.set(state);
  }
  phoneKeydown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'ArrowLeft',
      'ArrowRight',
      'Home',
      'End'
    ];
  
    if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
      return;
    }
  
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }
}
